export const getGtmProducts = () => window.__litium.store.getState().cart.gtmProducts;

export const getCurrency = () => window.__litium.store.getState().cart.currency;

export const formatPrice = price => {
    const currency = getCurrency();
    return price.replace(currency, "").replace(/ /g, "");
}

export const pushEcommerce = data => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push(data);

    // Call the event callback immediately if gtm isn't initialized
    if(typeof data.eventCallback == "function" && !isGtmInitialized()) {
        data.eventCallback();
    }
}

export const onCheckoutOption = (step, checkoutOption) => {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    'event': 'checkoutOption',
    'ecommerce': {
      'checkout_option': {
        'actionField': {'step': step, 'option': checkoutOption}
      }
    }
  });
}

export const addToCart = (gtmEcommerceItems) => {
    pushEcommerce({
        event: "add_to_cart",
        ecommerce: {
            items: gtmEcommerceItems
        }
    });
}

export const gtmShowCart = (cart) => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      'event': 'view_cart',
      'ecommerce': {
        'currency': cart.currency,
        'value': cart.gtmGrandTotal,
        'items': cart.orderRows.map(r => r.gtmEcommerceItem),
      },
    });
}

export const onCheckoutStep = (step, option, callback = null) => {
    const hasPushedStep = dataLayer.find(d => d.event == "checkout" && d.ecommerce && d.ecommerce.checkout.actionField.step == step) != null;

    if(hasPushedStep) {
        // This step was already pushed to the data layer, push "checkoutOption" instead
        pushEcommerce({
            event: "checkoutOption",
            ecommerce: {
                checkout_option: {
                    actionField: { 
                        step,
                        option
                    }
                }
            },
            eventCallback: callback,
            eventTimeout: 200
        });
    }else{
        pushEcommerce({
            event: "checkout", // checkoutOption if we already pushed this step to dataLayer
            ecommerce: {
                currencyCode: getCurrency(),
                checkout: {
                    actionField: { 
                        step,
                        option
                    },
                    products: getGtmProducts()
                }
            },
            eventCallback: callback,
            eventTimeout: 200
        });
    }
}

export const isGtmInitialized = () => {
    return dataLayer && dataLayer.length > 0 && dataLayer.find(d => d.event == "gtm.load");
}